var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3359 12.5C18.7962 12.5 19.1693 12.8731 19.1693 13.3333V16.6667C19.1693 18.0474 18.05 19.1667 16.6693 19.1667H3.33594C1.95523 19.1667 0.835938 18.0474 0.835938 16.6667V13.3333C0.835938 12.8731 1.20903 12.5 1.66927 12.5C2.12951 12.5 2.5026 12.8731 2.5026 13.3333V16.6667C2.5026 17.1269 2.8757 17.5 3.33594 17.5H16.6693C17.1295 17.5 17.5026 17.1269 17.5026 16.6667V13.3333C17.5026 12.8731 17.8757 12.5 18.3359 12.5ZM10.0026 0C10.4628 0 10.8359 0.373096 10.8359 0.833333V10.4882L13.58 7.74408C13.9055 7.41864 14.4331 7.41864 14.7585 7.74408C15.084 8.06951 15.084 8.59715 14.7585 8.92259L10.5919 13.0893C10.4291 13.252 10.2159 13.3333 10.0026 13.3333C9.78934 13.3333 9.57607 13.252 9.41335 13.0893L5.24668 8.92259C4.92124 8.59715 4.92124 8.06951 5.24668 7.74408C5.57212 7.41864 6.09976 7.41864 6.42519 7.74408L9.16927 10.4882V0.833333C9.16927 0.373096 9.54237 0 10.0026 0Z",
    fill: "#007A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlue);
export default __webpack_public_path__ + "static/media/download-blue.76a5782bf0496a773bb5673ad6708225.svg";
export { ForwardRef as ReactComponent };